const CheveronDown = ({ secondCheveron = false }) =>
  secondCheveron ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M15.8495 5.07465C15.7352 4.95013 15.5816 4.88965 15.428 4.88965C15.289 4.88965 15.1501 4.93967 15.0401 5.04085L7.999 11.5141L0.959307 5.07109C0.727151 4.85763 0.364987 4.87097 0.15176 5.10333C-0.0625378 5.33459 -0.048037 5.69356 0.183569 5.90702L7.61257 12.7379C7.83244 12.9402 8.16832 12.9402 8.38833 12.7379L15.8173 5.90702C16.0459 5.66168 16.0638 5.3059 15.8495 5.07465Z"
        fill="#ED3A56"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M14.274 18.3295C13.7966 18.8068 13.0248 18.8068 12.5525 18.3295L2.79741 8.57949C2.32007 8.10215 2.32007 7.33027 2.79741 6.85801C3.27475 6.38574 4.04663 6.38066 4.51889 6.85801L13.4056 15.7447L22.2974 6.85293C22.7748 6.37558 23.5466 6.37558 24.0189 6.85293C24.4912 7.33027 24.4962 8.10215 24.0189 8.57441L14.274 18.3295Z"
        fill="white"
      />
    </svg>
  );

export default CheveronDown;
